// extracted by mini-css-extract-plugin
export default {"button":"xy98P","iconFilters":"qe2HC"};